export default __webpack_public_path__ + "static/media/default-background-desktop.edeabf8e.mp4";